module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Rectangle-ed8ee07ccbfdf81be09d52912834da2e.svg";